<template>
  <div
    class="tw-flex tw-h-16 tw-mb-4 tw-items-center tw-justify-between tw-cursor-pointer tw-p-2 transition-medium hover:tw-bg-grey-lighter"
    :class="{ 'hover:tw-bg-success tw-bg-success tw-text-white': selected }"
    @click="handleClick"
    :data-preview="false"
  >
    <div
      class="tw-w-12 tw-h-12 tw-border tw-border-grey-light"
      :style="thumbnailBackground"
    ></div>
    <div class="tw-w-1/4 truncate" v-text="video.name"></div>
    <div
      class="tw-w-1/4 truncate tw-hidden md:tw-block"
      v-text="truncatedDescription"
    ></div>
    <div class="tw-w-32 truncate" v-text="formattedUploadedAt"></div>
    <div
      class="tw-w-24 tw-text-right tw-hidden md:tw-block"
      v-text="video.size"
    ></div>
    <div
      class="tw-w-24 tw-text-center tw-p-6"
      :class="{ 'tw-text-white': selected, 'tw-text-blue': !selected }"
      :data-preview="true"
    >
      <i class="fal fa-search" :data-preview="true"></i>
    </div>
  </div>
</template>

<script>
  import mediaMixin from '../media';
  import { format } from "../../../moment";

  export default {
    name: 'MediaListElement',

    mixins: [
      mediaMixin,
    ],

    computed: {
      thumbnailBackground() {
        return {
          backgroundImage: `url(${ this.video.thumbnail })`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'auto 40px',
        };
      },
      truncatedDescription() {
        return this.video.description.substring(0, 32) + (this.video.description.length > 32 ? '...' : '');
      },
      formattedUploadedAt() {
        return moment(this.video.uploaded_at).format(format.date)
      }
    },

    methods: {
      handleClick(event) {
        if (!event.target.dataset.preview) {
          this.changeStatus(this.selected ? 'deselected' : 'selected');
        } else {
          this.$emit('preview', this.video.id);
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .truncate {
    @media only screen and (max-width: 480px) {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
</style>
